__turbopack_context__.v({
  "btn": "Cell-module__EOnG9a__btn",
  "inert": "Cell-module__EOnG9a__inert",
});
